import { previewActions } from "../action/types";

const initialState = {
	isPreview: false,
	previewData: null,
};

const menuPreviewReducer = (state = initialState, action) => {
	switch (action.type) {
		case previewActions.MENU_PREVIEW_ADD: {
			// console.log('menuPreviewReducer ', previewActions.MENU_PREVIEW_ADD, action.payload);
			const {  previewData } = action.payload;
			const object = {
                ...state,
				isPreview: true,
				previewData,
            }
			return object;
		}
		case previewActions.MENU_PREVIEW_CLEAR: {
			const object = {
                ...state,
				isPreview: false,
				previewData: null,
            }
			return object;
		}

		default:
			return state;
	}
};

export default menuPreviewReducer;